import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

//import { I18nModule } from '@app/i18n';
import { MaterialModule } from '@app/material.module';

import { AuthModule } from '@app/auth';
import { ShellComponent } from './shell.component';
import { DashboardModule } from '@app/dashboard/dashboard.module';

import { ShellRoutingModule } from './shell-routing.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,

    //NgxFaceAvatarModule,

    AuthModule,
    DashboardModule,

    //I18nModule,
    RouterModule,
    ShellRoutingModule,
  ],
  declarations: [
    ShellComponent,
  ],
  providers: [
  ],
  exports: [],
})
export class ShellModule {}
